import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { SearchType } from "@utils/node/search"

const TABS: { label: string; value: SearchType }[] = [
  { label: "Name", value: "label" },
  { label: "Unit", value: "unit" },
  { label: "Mnemonic", value: "mnemonic" },
  { label: "Description", value: "description" },
  { label: "Group", value: "group" },
  { label: "Type", value: "type" },
  { label: "Link", value: "link" },
]

type SearchTabButtonsProps = {
  value: SearchType
  onChange: (value: SearchType) => void
}

const SearchTabButtons = (props: SearchTabButtonsProps) => {
  return (
    <ToggleButtonGroup fullWidth value={props.value} size="small" aria-label="Search button group">
      {TABS.map(({ label, value }) => (
        <ToggleButton
          key={value}
          value={value}
          sx={{ fontSize: "10pt" }}
          onClick={() => props.onChange(value)}
        >
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default SearchTabButtons
